import http from '@api'
import { HOUSE_FILTER_ALIAS, HOUSE_TYPE_ID, NEW_ZEALAND } from '@config'
import getHouseRoute from '@plugin/searchRoute/modules/house'
import { idsToSuburbsServer, suburbsToIds } from '@plugin/searchRoute/utils'
import { getHouseSearchTypeData, slugToId, toNumber } from '@utils'
import { assign, concat, filter, find, get, isArray, isFunction, map, pick, size } from 'lodash-es'


/**
 * state转query
 * @param {object} state
 * @returns query
 */
export function slugToQuery(state) {
  const { slug, type, searchParams = {}, pageSize } = state
  const { filter } = searchParams
  const houseRoute = getHouseRoute()
  houseRoute.fromSlug(slug)
  houseRoute.setSearchTypeId(type)

  function next(handle) {
    isFunction(handle) && handle(houseRoute)
    return next
  }

  next.toString = next.valueOf = () => {
    return assign(houseRoute.toQuery(pageSize), filter ? { filter } : undefined)
  }
  return next
}


/**
 * slug转数据
 * @param {string} slug 
 * @returns object 
 */
export function getSlugData(slug) {
  const houseRoute = getHouseRoute()
  houseRoute.fromSlug(slug)
  return houseRoute
}

/**
 * 获取页面基础数据
 * @param {string} slug 
 * @param {string} type 
 * @returns data
 */
export async function getBasicData(slug, type) {
  const houseRoute = getHouseRoute()
  houseRoute.fromSlug(slug)

  const { typeId = 1 } = getHouseSearchTypeData({ type })
  const filterMeta = await http.get('houses/filter/meta', { typeId })

  let propertyTypeLabel = ''
  if (size(houseRoute['property-type']) > 0) {
    // 这里是为了处理这种错误的url链接，在search/commercial-property-for-sale后面居然有property-type
    // https://www.oneroof.co.nz/search/commercial-property-for-sale/property-type_retail-5_page_1
    // https://htgy20230425225024046.pingcode.com/pjm/items/6502a0b4fc6214f4bb87ca85?id=#HG-1027 27032 SEO COMERCIAL SERPS: <h1>, <title> & Breadcrumb not configured correctly for location SERP + Filtered SERPS (HIGH)
    const aliasList = concat(
      HOUSE_FILTER_ALIAS.propertyType,
      [
        HOUSE_TYPE_ID['commercial-property-for-sale'],
        HOUSE_TYPE_ID['commercial-property-for-lease'],
        HOUSE_TYPE_ID['businesses-for-sale']
      ].includes(typeId) ? HOUSE_FILTER_ALIAS.categories : []
    )
    const propertyType = find(filterMeta, item => aliasList.includes(item.alias))
    if (propertyType) {
      const ids = map(houseRoute['property-type'], item => toNumber(slugToId(item)))
      const d = filter(propertyType.children, item => ids.includes(toNumber(item.value)))
      propertyTypeLabel = map(d, 'labelPl')
    }
  }

  let categoryLabel = ''
  if (size(houseRoute.categories) > 0) {
    const categories = find(filterMeta, item => HOUSE_FILTER_ALIAS.categories.includes(item.alias))
    if (categories) {
      const ids = map(houseRoute.categories, item => toNumber(slugToId(item)))
      const d = filter(categories.children, item => ids.includes(toNumber(item.value)))
      categoryLabel = map(d, 'labelPl')
    }
  }

  const suburbIds = suburbsToIds(concat(houseRoute.region, houseRoute.district, houseRoute.suburb)).idStr()
  let suburbs = await idsToSuburbsServer(suburbIds)
  if (houseRoute.hasNewZealand()) {
    if (isArray(suburbs)) {
      suburbs.push(NEW_ZEALAND)
    } else {
      suburbs = [NEW_ZEALAND]
    }
  }
  return {
    suburbs,
    filterMeta,
    propertyTypeLabel,
    categoryLabel
  }
}

/**
 * 获取房源列表数据
 * @param {object} state 
 * @returns [data, totlas, pageIndex] 
 */
export async function getListData(state) {
  const { slug } = state

  const query = slugToQuery(state).toString()
  query.showcasePriority = 1

  const data = await http.get('houses/list', query)

  return [
    data,
    get(data, 'headers.x-total-count'),
    getSlugData(slug).page,
    query
  ]
}

/**
 * get seo filter
 * @param {object} state 
 * @returns data
 */
export async function getSeoFilter(state) {
  const query = slugToQuery(state).toString()
  const res = await http.get('enum/seo-filters', pick(query, ['typeId', 'categoryId', 'regionId', 'districtId', 'suburbId']))
  return filter(res, item => size(item.data) > 0)
}